import React from 'react'

export default function ImageLabel({label}) {
  return (
    <div className="ant-form-item-label">
    <label className="ant-form-item-required" title={label}>{label}</label>
  </div>
  )
}
